import CodelocksPeriodSelectorJson from './interfaces/CodelocksPeriodSelectorJson'
import RelativeDurationPeriod from '../../period/RelativeDurationPeriod'

export default class CodelocksPeriodSelector {
  minDuration: RelativeDurationPeriod
  maxDuration: RelativeDurationPeriod | null

  constructor(
    minDuration: RelativeDurationPeriod,
    maxDuration: RelativeDurationPeriod | null,
  ) {
    this.minDuration = minDuration
    this.maxDuration = maxDuration
  }

  static fromJson(data: CodelocksPeriodSelectorJson) {
    return new this(
      RelativeDurationPeriod.fromJson(data.minDuration),
      data.maxDuration
        ? RelativeDurationPeriod.fromJson(data.maxDuration)
        : null,
    )
  }
}
